<awc-form-select
  label="Rolling Resistance Type"
  placeholder="Rolling Resistance..."
  [options]="rollingResistanceKeys"
  [value]="[rollingResistanceKey]"
  (valueChange)="selectionItems('' + $event?.[0], 'rolling_resistance_key', 'rolling_resistance_coefficient')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<app-input
  label="Rolling Resistance"
  placeholder="Rolling Resistance..."
  [cyData]="'wheel-rolling_resistance_coefficient'"
  [value]="rollingResistance"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_rolling_resistance_coefficient'"
  [updater]="update"
  [readOnly]="rollingResistanceKey !== 'manual'"
  (update)="setPartValue(''+$event, 'rolling_resistance_coefficient', part.id+'_rolling_resistance_coefficient')">
</app-input>

<awc-form-select
  label="Traction Coefficient Type"
  placeholder="Traction Coefficient..."
  [options]="tractionCoefficientKeys"
  [value]="[tractionCoefficientKey]"
  (valueChange)="selectionItems('' + $event?.[0], 'traction_coefficient_key', 'traction_coefficient')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<app-input
  label="Traction Coefficient"
  placeholder="Traction..."
  [cyData]="'wheel-traction_coefficient'"
  [value]="tractionCoefficient"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_traction_coefficient'"
  [updater]="update"
  [readOnly]="tractionCoefficientKey !== 'manual'"
  (update)="setPartValue(''+$event, 'traction_coefficient', part.id+'_traction_coefficient')">
</app-input>

<app-input
  label="Rolling Radius"
  placeholder="Rolling Radius..."
  [value]="part.rolling_radius"
  [unit]="UnitType.LENGTH"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_rolling_radius'"
  [updater]="update"
  [readOnly]="readonly"
  (update)="setPart.emit([''+$event, 'rolling_radius', part.id+'_rolling_radius'])"></app-input>
<app-input
  label="Mass"
  placeholder="Optional..."
  [value]="part.mass"
  [unit]="UnitType.MASS"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_mass'"
  [updater]="update"
  [readOnly]="readonly"
  (update)="setPart.emit([''+$event, 'mass', part.id+'_mass'])"></app-input>
